import { useSalon } from '../../data/salon.js';
import { MyWeek } from './MyWeek.js';
import { PractitionerTimeOffPanel } from './PractitionerTimeOffPanel.js';

/**
 * WS11 — "My week" route. Two surfaces for the practitioner (identity-spanning) layer:
 *  • The unified diary — the REAL flagship: one day-grouped agenda across every place the practitioner
 *    works, colour-coded by location, with a place legend, per-item location pill, week navigation and
 *    a one-tap "switch into <salon> to book" affordance (there is no cross-tenant write). Built from the
 *    read-side-union hooks (useMyWeek + useResidencies). Replaces the design-gated MyWeekScaffold (kept
 *    in the tree, unmounted, as a fallback).
 *  • Practitioner-level time off — a REAL, usable surface ("sick is sick everywhere").
 *
 * No RBAC gate: every authenticated practitioner has a "my week" (it is keyed on their own session,
 * across whatever memberships they hold — a single-salon employee simply sees one location). The
 * salon-side residency roster + invite live elsewhere (owner/manager-gated).
 *
 * TIMEZONE: the diary renders in the ACTIVE salon's timezone and labels itself with that salon's name
 * ("times shown in <salon> time"); per-leg timezones are a deferred API change (HONESTY).
 */
export function MyWeekPage() {
  const { data: salon } = useSalon();
  const tz = salon?.timezone ?? 'Europe/London';

  return (
    <>
      <div className="topbar">
        <div className="topbar__title">My week</div>
      </div>

      <div className="screen-scroll">
        <div
          className="screen-pad"
          style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 880 }}
        >
          <MyWeek tz={tz} salonName={salon?.name} activeSalonId={salon?.id} />
          <PractitionerTimeOffPanel tz={tz} />
        </div>
      </div>
    </>
  );
}
